import React, { useEffect, useState } from 'react';
import { useHistory, useRouteMatch } from 'react-router-dom';
import { useSnackbar } from 'notistack';
import ButtonSlim from '../../../../web-app-components/components/ButtonSlim';
import TextInput from '../../../../web-app-components/components/TextInput';
import useStateThrottled from '../../../../web-app-components/hooks/useStateThrottled';
import makeStyles from '@material-ui/core/styles/makeStyles';
import AddIcon from '@material-ui/icons/AddCircleOutline';
import SearchIcon from '@material-ui/icons/Search';
import InputAdornment from '@material-ui/core/InputAdornment';
import Paper from '@material-ui/core/Paper';
import { DataGrid } from '@material-ui/data-grid';

import prizesClient from '../../../../clients/prizes';

const columns = [
  {
    field: 'Name',
    headerName: 'Pavadinimas',
    flex: 1,
    sortable: false,
  },
  {
    field: 'descriptionPreview',
    headerName: 'Aprašymas',
    flex: 1,
    sortable: false,
    valueGetter: (params) => params.row?.descriptionPreview ?? '—',
  },
  {
    field: 'objectTitle',
    headerName: 'Objektas',
    flex: 0.8,
    sortable: false,
    valueGetter: (params) => params.row?.objectTitle ?? '—',
  },
];

const useStyles = makeStyles((theme) => ({
  controls: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: theme.spacing(1),
    gap: theme.spacing(1),
    flexWrap: 'wrap',
    '& > :not(:last-child)': {
      marginRight: theme.spacing(1),
    },
  },
  searchInput: {
    flex: '0 1 300px',
  },
}));

const PrizesList = () => {
  const classes = useStyles();
  const history = useHistory();
  const { path } = useRouteMatch();
  const { enqueueSnackbar } = useSnackbar();

  const [throttledSearchTerm, searchTerm, setSearchTerm] = useStateThrottled('', 500);
  const [rows, setRows] = useState();

  useEffect(() => {
    (async () => {
      try {
        const query = {
          sort: 'createdAt:desc',
          populate: {
            Object: {
              fields: ['Title', 'documentId'],
            },
          },
        };
        const filtersObj = {};
        if (throttledSearchTerm && throttledSearchTerm.trim()) {
          filtersObj.Name = { $containsi: throttledSearchTerm.trim() };
        }
        if (Object.keys(filtersObj).length > 0) {
          query.filters = filtersObj;
        }
        const result = await prizesClient.find(query);
        const list = Array.isArray(result) ? result : result?.data ?? [];
        setRows(
          list.map((row) => {
            const obj = row.Object;
            const objectTitle = obj?.Title || obj?.documentId || '—';
            const desc = row.Description;
            const plain =
              desc && String(desc).trim()
                ? String(desc).replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim()
                : '';
            const descriptionPreview =
              plain.length > 0
                ? plain.slice(0, 80) + (plain.length > 80 ? '…' : '')
                : '—';
            return {
              ...row,
              id: row.documentId ?? row.id,
              objectTitle,
              descriptionPreview,
            };
          })
        );
      } catch (error) {
        enqueueSnackbar('Nepavyko gauti prizų sąrašo. Bandykite atidaryti iš naujo.', {
          variant: 'error',
        });
      }
    })();
  }, [throttledSearchTerm, enqueueSnackbar]);

  const handleSearchChange = ({ target: { value } }) => setSearchTerm(value);
  const handleNewClick = () => history.push(`${path}/new`);
  const handleRowClick = ({ id }) => history.push(`${path}/${id}`);

  return (
    <div>
      <div className={classes.controls}>
        <TextInput
          className={classes.searchInput}
          placeholder="Ieškoti pagal pavadinimą..."
          value={searchTerm}
          onChange={handleSearchChange}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
        />
        <ButtonSlim startIcon={<AddIcon />} onClick={handleNewClick}>
          Naujas prizas
        </ButtonSlim>
      </div>
      <Paper>
        <DataGrid
          columns={columns}
          rows={rows || []}
          loading={rows === undefined}
          onRowClick={handleRowClick}
          autoHeight
          disableColumnMenu
          disableSelectionOnClick
        />
      </Paper>
    </div>
  );
};

export default PrizesList;
